"use client";

import { useEffect } from "react";

export function ClarityProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID &&
      process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === "true"
    ) {
      // Dynamic import — @microsoft/clarity is NOT in the main bundle
      import("@microsoft/clarity").then((mod) => {
        mod.default.init(process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID!);
      });
    }
  }, []);

  return <>{children}</>;
}
